import {
  Theme,
  color,
  inputElementStyles,
  optionStyles,
  rem,
  radius,
  border,
  nav,
} from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('feedback-text-input');
export const theme = new Theme(tag);

export const styles = [
  optionStyles,
  css`
    :host {
      align-items: normal;
      display: flex;
      flex-direction: column;
      row-gap: ${rem(4)};
    }

    .input-wrapper {
      box-sizing: border-box;
      display: inline-block;
      inline-size: 100%;
      position: relative;
    }

    :where(textarea) {
      ${inputElementStyles};
      background-color: ${color('white')};
      border-radius: ${radius('large')};
      box-sizing: border-box;
      color: ${color('black')};
      display: block;
      inline-size: 100%;
      min-block-size: ${rem(36)};
      overflow-y: hidden;
      padding: ${rem(8, 42, 8, 18)};
      resize: none;
      ${nav('medium')};
    }

    textarea::placeholder {
      color: ${color('grey', 600)};
    }

    :where(a-loader, a-icon) {
      color: ${color('blue', 600)};
      inset-block-end: ${rem(18)};
      inset-inline-end: ${rem(20)};
      position: absolute;
      transform: translateY(50%);
    }

    :where(a-icon:hover) {
      cursor: pointer;
    }

    :host([disabled]) {
      :where(textarea) {
        background: ${color('neutral', 200)};
        border: ${border(1, 'neutral', 300)};
        color: ${color('neutral', 400)};
        cursor: not-allowed;
      }
      :where(textarea)::placeholder {
        color: ${color('neutral', 400)};
      }
      :where(a-icon) {
        color: ${color('neutral', 400)};
      }
    }
  `,
];
